import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import BrandLogo from './BrandLogo';

export default function GuardianAuthShell({ title, subtitle, children, onCancel }) {
  return (
    <Box sx={{ display: 'flex', minHeight: 'calc(100vh - 73px)' }}>
      <Box
        className="il-auth-hero"
        sx={{
          display: { xs: 'none', lg: 'flex' },
          width: { lg: '45%', xl: '50%' },
          flexDirection: 'column',
          p: 6,
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ maxWidth: 420 }}>
            <Typography
              variant="h4"
              sx={{ color: 'text.primary', fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.25 }}
            >
              See disasters before they escalate. Respond before they spread.
            </Typography>
            <Typography sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.6 }}>
              Real-time AI transforms environmental data into predictive insights, helping emergency
              teams make faster, more informed operational decisions.
            </Typography>
          </Box>
        </Box>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          Trusted by emergency management and critical infrastructure teams
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          py: 6,
          bgcolor: 'background.default',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 440 }}>
          {onCancel && (
            <Button
              variant="text"
              onClick={onCancel}
              sx={{ mb: 2, textTransform: 'none', color: 'text.secondary' }}
            >
              ← Back to Guardian
            </Button>
          )}
          <Box sx={{ mb: 3, display: { lg: 'none' } }}>
            <BrandLogo size="md" />
          </Box>
          <Box className="il-auth-panel" sx={{ p: { xs: 3, sm: 5 } }}>
            <Typography variant="h5" sx={{ fontWeight: 600, letterSpacing: '-0.02em', color: 'text.primary' }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                {subtitle}
              </Typography>
            )}
            <Box sx={{ mt: 4 }}>{children}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
